
































import { Vue, Component, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import PersonSearch from 'components/account/PersonSearch.vue'
import SelectRole from 'components/presenter/item/team/SelectRole.vue'
import api from 'src/assets/api/gql'
import ItemShareCreate from 'src/graphql/item_share/ItemShareCreate.gql'
import { PersonPublicProfile, ItemShareRole } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    PersonSearch,
    SelectRole
  }
})
export default class ItemTeamMenuButtonAdd extends Vue {
  loading = false
  person: PersonPublicProfile | null = null

  get item () {
    return store.state.presenter.item!
  }

  @Ref()
  readonly selectPersonDialog!: DialogFullscreen

  @Ref()
  readonly selectRoleDialog!: SelectRole

  selectRole (person: PersonPublicProfile) {
    this.person = person
    this.selectRoleDialog.show()
  }

  async add (personId: number, role: ItemShareRole) {
    this.selectPersonDialog.hide()
    this.loading = true
    const { data: { createItemShare } } = await api.mutate({
      query: ItemShareCreate,
      variables: {
        input: {
          path: this.item.path,
          personId,
          role
        }
      }
    })
    this.loading = false
    if (createItemShare) {
      this.$emit('set', createItemShare.itemShare)
    }
  }
}
